module.exports = __webpack_public_path__ + "static/media/emvio.97654939.woff";